import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Table } from 'react-bootstrap';

import { isPresent } from 'helpers/string_helpers';

export default class SelectContacts extends React.Component {

  static propTypes = {
    contacts: PropTypes.arrayOf(PropTypes.shape({
      emailAddresses: PropTypes.arrayOf(PropTypes.shape({
        email: PropTypes.string.isRequired,
        label: PropTypes.string
      })).isRequired,
      phoneNumbers: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        number: PropTypes.string.isRequired
      })).isRequired
    })).isRequired,
    duplicateEmails: PropTypes.array.isRequired,
    handleCancelImport: PropTypes.func.isRequired,
    handleContactTypeChange: PropTypes.func.isRequired,
    handleImport: PropTypes.func.isRequired,
    selectedContacts: PropTypes.array.isRequired,
    onSelectAll: PropTypes.func.isRequired,
    onSelectContact: PropTypes.func.isRequired
  };

  static contactTypes = {
    person: "Contacts::Person",
    company: "Contacts::Company"
  };

  warningText = (contact) => {
    const { duplicateEmails } = this.props;
    const index = duplicateEmails.indexOf(contact.email);
    if (contact.nylasUserExists) {
      return "Already Syncing";
    }
    if (contact.existsInDatabase) {
      return "This contact already exists in your Database. " +
      "Select the contact and the imported information will merge with the contact in your database.";
    }
    if (index >= 0) {
      return "Duplicate email address as another contact in the import. Please select one.";
    }
    return "";
  };

  rowClass = (contact) => {
    const { duplicateEmails, selectedContacts } = this.props;
    const index = duplicateEmails.indexOf(contact.email);
    const checked = selectedContacts.some(selectedContact => selectedContact.id === contact.id);

    let duplicateChecked = false;
    if (index >= 0) {
      duplicateChecked = selectedContacts.some(selectedContact => selectedContact.email === contact.email);
    }
    if (checked) {
      return "";
    }
    if (duplicateChecked || contact.nylasUserExists) {
      return classNames({
        "text-muted": true
      });
    }
    if (contact.existsInDatabase) {
      return classNames({
        "alert-warning": true
      });
    }
    if (index >= 0) {
      return classNames({
        "alert-danger": true
      });
    }
  };

  warningsCount = () => {
    const { contacts, selectedContacts, duplicateEmails } = this.props;
    let warnings = 0;
    contacts.forEach((contact) => {
      const checked = selectedContacts.some(selectedContact => selectedContact.id === contact.id);
      if (!checked && !contact.nylasUserExists) {
        if (contact.existsInDatabase) {
          warnings++;
        } else {
          const index = duplicateEmails.indexOf(contact.email);
          if (index >= 0) {
            const duplicateChecked = selectedContacts.some(selectedContact => selectedContact.email === contact.email);
            if (!duplicateChecked) {
              warnings++;
            }
          }
        }
      }
    });
    return warnings;
  };

  render() {
    return (
      <div className="container">
        <div className="page-header">
          <h3>
            Import Contacts
          </h3>
        </div>
        {this.renderImportContainer()}
      </div>
    );
  }

  renderImportContainer() {
    const { contacts, selectedContacts, handleCancelImport } = this.props;

    if (contacts.length === 0) {
      return (
        <div className="container merge-container white border-top-0">
          <p className="text-lg">
            There are no available contacts to import.
            If you have contacts in your account, it may take up to 10 minutes for them to display here.
          </p>
          <div>
            <button
              className='btn btn-sm btn-cancel'
              onClick={handleCancelImport}
            >
              Back To Integrations
            </button>
          </div>
        </div>
      );
    } else {
      const warnings = this.warningsCount();
      return (
        <div className="container merge-container white border-top-0">
          <p className="text-lg">
            Review the contacts you would like to import.
            Those marked as duplicates will not be imported.
          </p>
          <p className="text-lg">
            {selectedContacts.length} {selectedContacts.length == 1 ? "Contact" : "Contacts" } selected
            {warnings > 0 &&
              <span className="text-danger"> | {warnings} {warnings == 1 ? "Warning" : "Warnings"}</span>
            }
          </p>
          {this.renderImportTable()}
        </div>
      );
    }
  }
  renderImportTable() {
    const { handleCancelImport, handleImport } = this.props;
    return (
      <div>
        <Table>
          <thead>
            {this.renderHeaderColumns()}
          </thead>
          <tbody>
            {this.renderTableContent()}
          </tbody>
        </Table>
        <div>
          <button
            className='btn btn-sm btn-cancel'
            onClick={handleCancelImport}
          >
            Cancel
          </button>
          <button
            className='btn btn-sm btn-save left-buffer-md'
            onClick={handleImport}
          >
            Run Import
          </button>
        </div>
      </div>
    );
  }

  renderHeaderColumns() {
    const { selectedContacts, onSelectAll } = this.props;

    return (
      <tr>
        <td>
          <input
            checked={selectedContacts.length > 0}
            type="checkbox"
            onChange={onSelectAll}
          />
        </td>
        <td>Name</td>
        <td>Email</td>
        <td>Phone Numbers</td>
        <td>Type</td>
        <td>Warnings</td>
      </tr>
    );
  }

  renderEmails(emailAddresses = []) {
    return emailAddresses.map((email) => {
      const key = `${email.label}:${email.email}`;
      const label = isPresent(email.label) ? <strong>{email.label}: </strong> : null;

      return (
        <div key={key}>{label}{email.email}</div>
      );
    });
  }

  renderNumbers(phoneNumbers = []) {
    return phoneNumbers.map((number) => {
      const label = isPresent(number.label) ? <strong>{number.label}: </strong> : null;

      // TODO: FIX
      return (
        <div key={number.label + number.number}>{label}{number.number}</div>
      );
    });
  }

  renderTableContent() {
    const rows = [];
    const {
      contacts,
      selectedContacts,
      onSelectContact,
      handleContactTypeChange
    } = this.props;

    const contactTypes = SelectContacts.contactTypes;

    contacts.map((contact) => {
      const checked = selectedContacts.some(selectedContact => selectedContact.id === contact.id);
      const rowClass = this.rowClass(contact);
      const warningText = this.warningText(contact);
      rows.push(
        <tr
          className={rowClass}
          key={contact.id}
        >
          <td>
            <input
              checked={checked}
              disabled={contact.nylasUserExists}
              type="checkbox"
              value={contact.id}
              onChange={onSelectContact}
            />
          </td>
          <td>{contact.firstName} {contact.lastName}</td>
          <td>{this.renderEmails(contact.emailAddresses)}</td>
          <td name="phone-numbers">
            {this.renderNumbers(contact.phoneNumbers)}
          </td>
          <td>
            <select
              className="form-control borderless d-inline-block w-auto"
              defaultValue={contactTypes.person}
              id={contact.id}
              onChange={handleContactTypeChange}
            >
              <option value={contactTypes.person}>Contact</option>
              <option value={contactTypes.company}>Company</option>
            </select>
          </td>
          <td>{warningText}</td>
        </tr>
      );
    });
    return rows;
  }
}
